export const SUFFIX_IMAGE = ['jpg', 'jpeg', 'png', 'gif', 'svg']